<mat-expansion-panel [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ title }}</mat-panel-title>
  </mat-expansion-panel-header>
  <div class="section-grid" [style.grid-template-columns]="gridColumns">
    <ng-content />
  </div>
</mat-expansion-panel>
